import React from 'react';
import { Link } from 'react-router-dom';
import styles from './FlagshipSection.module.css';

export default function FlagshipSection() {
  return (
    <section className={styles.flagship} id="flagship">
      <div className={styles.divider} aria-hidden="true"><span /></div>
      <div className={`${styles.container} ${styles.intro}`}>
        <p className={styles.overline}>OUR FLAGSHIP TITLE</p>
      </div>
      <div className={`${styles.container} ${styles.grid}`}>
        <div className={styles.media}>
          <Link
            to="/inceptum"
            className={styles.mediaImageLink}
          >
            <img
              src="/images/webp/BoxFront_1045x820.webp"
              srcSet="/images/webp/BoxFront_520w.webp 520w, /images/webp/BoxFront_1045x820.webp 1045w"
              sizes="(max-width: 768px) 90vw, 500px"
              alt="INCEPTUM board game box art - open product page"
              width={776}
              height={629}
              loading="lazy"
              className={styles.mediaBaseImage}
            />
          </Link>
        </div>
        <div className={styles.copy}>
          <h2>INCEPTUM: Dawn of Civilizations</h2>
          <p className={styles.meta}>
            <span className={styles.metaLine}>2–4 Players · 60–120 Minutes</span>
            <span className={`${styles.metaLine} ${styles.metaLineNowrap}`}>Engine Building · Non-Combat · High Variability</span>
          </p>
          <div className={styles.titleDivider} aria-hidden="true" />
          <p className={styles.kicker}><strong>A medium-heavy, engine-building strategy board game where asymmetry, timing, and long-term planning decide everything.</strong></p>
          <p className={styles.desc}>
            INCEPTUM: Dawn of Civilizations is the debut title from StratMech Studios. Players expand cities, develop technologies, and race to claim Wonders while shared opportunities shift from game to game.
          </p>
        </div>
        <Link to="/inceptum" className={styles.mediaCta}>Explore INCEPTUM</Link>
        <p className={styles.launchCallout}>International Publishing &amp; Campaign Partnerships Open</p>
      </div>
    </section>
  );
}
